<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-cogs"></i>
						Configuration
					</a>
				</li>
				<li class="breadcrumb-item active">Payment Mode</li>
			</ol>
		</nav>
		<section class="content">
			<div class="container-fluid">
				<div class="row justify-content-md-center">
					<div class="col-sm-4">
						<form class="card" @submit.prevent="submitForm()">
							<div class="card-header">
								<h3 class="card-title" v-if="status">New Payment Mode</h3>
								<h3 class="card-title" v-else>Update Payment Mode</h3>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-sm-12">
										<div class="form-group">
											<label for="payment_mode">Payment Mode *</label>
											<input type="text" class="form-control form-control-sm"
												:class="{ 'is-invalid': errors.payment_mode }"
												placeholder="Payment Mode" v-model="payment_mode.payment_mode"
												ref="payment_mode" />
											<span v-if="errors.payment_mode" class="invalid-feedback">{{
												errors.payment_mode[0] }}</span>
										</div>
									</div>
									<div class="col-sm-12">
										<div class="form-group">
											<label for="description">Description</label>
											<textarea type="text" class="form-control form-control-sm"
												:class="{ 'is-invalid': errors.description }" placeholder="Description"
												v-model="payment_mode.description"></textarea>
											<span v-if="errors.description" class="invalid-feedback">{{
												errors.description[0] }}</span>
										</div>
									</div>
								</div>
							</div>
							<div class="card-footer">
								<div class="float-right">
									<button class="btn btn-sm btn-outline-danger" type="button" @click="discard()"><i
											class="fas fa-ban"></i> Discard</button>
									<button class="btn btn-sm btn-outline-success" type="submit">
										<span v-if="status"> <i class="fas fa-save"></i> Submit </span>
										<span v-else> <i class="fas fa-save"></i> Update </span>
									</button>
								</div>
							</div>
						</form>
					</div>
					<div class="col-sm-8">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Payment Modes</h3>
								<div class="card-tools">
									<div
										class="custom-control custom-switch custom-switch-off-success custom-switch-on-danger">
										<input type="checkbox" class="custom-control-input" id="trashed"
											v-model="meta.trashed" @click="isTrashed" />
										<label class="custom-control-label" for="trashed">Trashed</label>
									</div>
								</div>
							</div>
							<div class="card-body">
								<div class="form-group">
									<input class="form-control form-control-sm" type="text" placeholder="Search"
										v-model="meta.search" @keyup="index" v-if="!meta.trashed" />
								</div>
								<table class="table table-responsive-sm table-bordered table-striped table-sm">
									<thead>
										<tr>
											<th class="text-center">#</th>
											<th @click="sort('payment_mode')">Payment Mode
												<span>
													<i v-if="meta.keyword == 'payment_mode' && meta.order_by == 'asc'"
														class="fas fa-sort-up"></i>
													<i v-else-if="meta.keyword == 'payment_mode' && meta.order_by == 'desc'"
														class="fas fa-sort-down"></i>
													<i v-else class="fas fa-sort"></i>
												</span>
											</th>
											<th @click="sort('description')">Description
												<span>
													<i v-if="meta.keyword == 'description' && meta.order_by == 'asc'"
														class="fas fa-sort-up"></i>
													<i v-else-if="meta.keyword == 'description' && meta.order_by == 'desc'"
														class="fas fa-sort-down"></i>
													<i v-else class="fas fa-sort"></i>
												</span>
											</th>
											<th class="text-center">Action</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(payment_mode, key) in payment_modes" :key="key">
											<td class="text-center">{{ meta.from + key }}</td>
											<td>{{ payment_mode.payment_mode }}</td>
											<td>{{ payment_mode.description }}</td>
											<td class="text-center" v-if="!meta.trashed">
												<button class="btn btn-xs btn-outline-success" data-toggle="tooltip"
													data-placement="bottom" title="Edit">
													<i class="fas fa-pencil-alt" @click="edit(payment_mode)"></i>
												</button>
												<button class="btn btn-xs btn-outline-danger" data-toggle="tooltip"
													data-placement="bottom" title="Delete"
													@click="deletePaymentType(payment_mode)">
													<i class="fas fa-trash-alt"></i>
												</button>
											</td>
											<td class="text-center" v-else>
												<button class="btn btn-xs btn-outline-success" data-toggle="tooltip"
													data-placement="bottom" title="Restore"
													@click="deletePaymentTyp(payment_mode)">
													<i class="fas fa-trash-restore"></i>
												</button>
											</td>
										</tr>
										<tr v-if="payment_modes.length <= 0">
											<td colspan="20" style="text-align: center;">No Records Found</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="card-footer">
								<div class="float-right">
									<Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage"
										:currentPage="meta.page" @pagechanged="onPageChange" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
export default {
	name: "Payment Mode",
	components: { Pagination },
	data() {
		return {
			status: true,
			meta: {
				search: "",
				order_by: "asc",
				keyword: "payment_mode",
				per_page: 10,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				maxPage: 1,
				trashed: false,
				branch_id: this.$store.getters.user.branch_id
			},
			payment_mode: {
				branch_id: this.$store.getters.user.branch_id,
				payment_mode_id: "",
				payment_mode: "",
				description: "",
			},
			payment_modes: [],
			branches: [],
			errors: [],
		};
	},
	mounted() {
		let vm = this;
		vm.getBranches();
		vm.index();
	},

	methods: {
		submitForm() {
			let vm = this;
			if (vm.status) {
				vm.create();
			} else {
				vm.update();
			}
		},

		edit(payment_mode) {
			let vm = this;
			(vm.status = false), (vm.payment_mode = payment_mode), vm.$refs.payment_mode.focus();
		},

		getBranches() {
			let vm = this;
			vm.$store.dispatch("post", { uri: "getBranches" }).then(function (response) {
				vm.branches = response.data.data;
			}).catch(function (error) {
				vm.$store.dispatch("error", error.response.data.message);
			});
		},

		index() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "paginatePaymentMode", data: vm.meta })
				.then(function (response) {
					vm.payment_modes = response.data.data;
					vm.meta.totalRows = response.data.meta.total;
					vm.meta.lastPage = response.data.meta.last_page;
					vm.meta.from = response.data.meta.from;
					vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		isTrashed() {
			let vm = this;
			vm.meta.trashed = !vm.meta.trashed;
			if (vm.meta.trashed)
				vm.meta.page = 1
			vm.index();
		},

		create() {
			let vm = this;
			let loader = vm.$loading.show();
			let uri = { uri: "addPaymentMode", data: vm.payment_mode };
			vm.$store
				.dispatch("post", uri)
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Payment Mode is successfully created");
					vm.discard();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		discard() {
			let vm = this;
			vm.payment_mode.payment_mode = "";
			vm.payment_mode.description = "";
			vm.errors = [];
			vm.status = true;
			vm.index();
		},

		update() {
			let vm = this;
			let loader = vm.$loading.show();
			let uri = { uri: "updatePaymentMode", data: vm.payment_mode };
			vm.$store
				.dispatch("post", uri)
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Payment Mode is successfully updated");
					vm.discard();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		deletePaymentType(payment_mode) {
			if (confirm("Do you want to continue... ?")) {
				let vm = this;
				let loader = vm.$loading.show();
				let uri = { uri: "deletePaymentMode", data: payment_mode };
				vm.$store
					.dispatch("post", uri)
					.then(function () {
						loader.hide();
						vm.$store.dispatch("success", "Payment Mode is successfully deleted");
						vm.index();
					})
					.catch(function (error) {
						loader.hide();
						vm.errors = error.response.data.errors;
						vm.$store.dispatch("error", error.response.data.message);
					});
			}
		},

		onPageChange(page) {
			this.meta.page = page;
			this.index();
		},
		sort(field) {
			this.meta.keyword = field;
			this.meta.order_by = this.meta.order_by == 'asc' ? 'desc' : 'asc';
			this.index();
		},
	},
};
</script>
